import React from 'react';
import {Form} from 'semantic-ui-react';
import {
  Checkbox,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {Alert} from 'componentLibrary';
import {isLoginGovUser} from 'common/utils';

import REST from 'go/requests/rest';

export class AuthSignWrapper extends React.Component {
  state = {
    password: undefined,
    authError: false,
    message: '',
    entityId: '',
    entityType: '',
  };

  getAuthentication = async (payload) => {
    const {username, entityId, entityType} = this.props;
    const loginGovIntegration = isLoginGovUser();

    if (loginGovIntegration) {
      await this.props.handleSubmit(payload, '', true);
      this.setState({
        entityId: entityId,
        entityType: entityType,
        message: '',
        authError: false,
      });
      return true;
    }

    const password = this.state.password;

    try {
      const res = await REST.auth.authLogin(username, password);

      if (res.status !== 200) {
        let message = this.props.invalidPasswordMessage
          ? this.props.invalidPasswordMessage
          : 'The application was not submitted because of an invalid password.';

        this.setState({
          authError: true,
          password: undefined,
          message,
        });
        return false;
      } else {
        this.setState({
          entityId: entityId,
          entityType: entityType,
          message: '',
          authError: false,
        });
        return true;
      }
    } catch (error) {
      console.error('Error occurred while submitting application:', error);
    }
    return false;
  };

  render() {
    const {confirmationLabel, errorAlertHeader} = this.props;
    const {password, confirmation, authError, message, entityType, entityId} = this.state;
    const loginGovIntegration = isLoginGovUser();
    const isValid = (loginGovIntegration || !_.isEmpty(password)) && !!confirmation;
    let confirmationLabelReplaced = loginGovIntegration
      ? _.replace(confirmationLabel, 'entering my password', 'checking this box')
      : confirmationLabel;
    confirmationLabelReplaced = loginGovIntegration
      ? _.replace(
          confirmationLabelReplaced,
          'signing this subapplication',
          'checking this box'
        )
      : confirmationLabelReplaced;
    return (
      <Form id="submission-signature-form">
        <Checkbox
          label={confirmationLabelReplaced}
          checked={!!confirmation}
          handleChange={(name, value) => this.setState({confirmation: !!value})}
        />
        {!loginGovIntegration && (
          <TextBoxField
            id="password"
            name="password"
            value={password}
            handleChange={(e, data) => this.setState({password: data.value})}
            title="Password"
            type="password"
            size="small"
            label="Please enter your password."
          />
        )}
        {authError && (
          <Alert alertType="error" header={errorAlertHeader || 'Unable to submit'}>
            <p>The request cannot be submitted due to the following:</p>
            <ul>
              <li>{message}</li>
            </ul>
          </Alert>
        )}
        {this.props.children(this.getAuthentication, isValid)}
      </Form>
    );
  }
}

export default AuthSignWrapper;
